module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-7-svgrepo-com.6f676ada.svg";